var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 162,
    viewBox: "0 0 161 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_141_11017)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_141_11017)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 12.2969,
    width: 114.739,
    height: 114.739,
    rx: 5.73696,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6367 69.6656C46.6367 67.9615 47.3137 66.3272 48.5187 65.1222C49.7237 63.9172 51.358 63.2402 53.0621 63.2402H64.3066V103.399H46.6367V69.6656Z",
    fill: "#31BF5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9746 42.359C81.9746 38.809 84.9881 35.9336 88.7052 35.9336H114.102V96.9748C114.102 100.525 111.088 103.4 107.371 103.4H81.9746V42.359Z",
    fill: "#FBB945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3086 56.9256C64.3086 53.3177 67.3221 50.3926 71.0392 50.3926H96.4356V96.8691C96.4356 100.477 93.4221 103.402 89.705 103.402H64.3086V56.9256Z",
    fill: "#FC868B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9746 103.402H89.7011C93.4182 103.402 96.4317 100.477 96.4317 96.8691V50.3926H81.9746V103.402Z",
    fill: "#F86126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3086 103.399L72.3323 103.396C74.038 103.396 75.6739 102.718 76.8803 101.513C78.0867 100.307 78.7649 98.6712 78.7657 96.9655V63.2402H64.3086V103.399Z",
    fill: "#962B48"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_141_11017",
    x: 0.0521603,
    y: 0.822955,
    width: 160.635,
    height: 160.635,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.4739
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.4739
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_141_11017"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_141_11017",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_141_11017"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 12.2969,
    width: 114.739,
    height: 114.739,
    rx: 5.73696,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.54520273809ddcdde13cf03974abb6cc.svg";
export { ForwardRef as ReactComponent };